var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flex flex-col", attrs: { "data-id": _vm.panelId } },
    [
      _c(
        "div",
        {
          staticClass:
            "sticky top-0 z-10 py-6 px-6 flex flex-col gap-2 bg-pure-white",
          attrs: { "data-id": _vm.panelId }
        },
        [
          _c(
            "div",
            {
              staticClass: "flex items-center justify-between gap-4",
              attrs: { "data-id": _vm.panelId }
            },
            [
              _c("BlTextTitle4", {
                staticClass: "truncate",
                attrs: {
                  "data-id": _vm.panelId,
                  title: _vm.creditPackageItem.name,
                  text: _vm.creditPackageItem.name
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "flex items-center gap-2",
                  attrs: { "data-id": _vm.panelId }
                },
                [
                  _c("BlChip", {
                    attrs: {
                      "data-id": _vm.panelId,
                      chip:
                        _vm.packageItemChips[_vm.creditPackageItem.status].chip,
                      color:
                        _vm.packageItemChips[_vm.creditPackageItem.status]
                          .color,
                      dense: ""
                    }
                  }),
                  _vm._v(" "),
                  _c("BlIcon", { attrs: { icon: "close", clickable: true } })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          !_vm.creditPackageItem.is_default
            ? _c(
                "div",
                {
                  staticClass: "grid grid-cols-2 gap-4",
                  attrs: { "data-id": _vm.panelId }
                },
                [
                  _c("BlInputButton", {
                    attrs: {
                      "data-id": _vm.panelId,
                      type: "outlined",
                      dense: "",
                      label: "Edit item"
                    },
                    on: {
                      clicked: function($event) {
                        _vm.editOpened = true
                      }
                    }
                  }),
                  _vm._v(" "),
                  _vm.creditPackageItem.status === "archived"
                    ? _c("BlInputButton", {
                        attrs: {
                          "data-id": _vm.panelId,
                          dense: "",
                          label: "Reactivate item",
                          loading: _vm.submitLoading
                        },
                        on: { clicked: _vm.onReactivate }
                      })
                    : _c("BlInputButton", {
                        attrs: {
                          "data-id": _vm.panelId,
                          type: "outlined",
                          dense: "",
                          label: "Archive item",
                          loading: _vm.submitLoading
                        },
                        on: {
                          clicked: function($event) {
                            _vm.archiveOpened = true
                          }
                        }
                      })
                ],
                1
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "px-6 flex flex-col gap-4",
          attrs: { "data-id": _vm.panelId }
        },
        [
          _c(
            "div",
            {
              staticClass: "flex flex-col gap-2",
              attrs: { "data-id": _vm.panelId }
            },
            [
              _c("BlTextBody2", {
                staticClass: "text-slate-700",
                attrs: { "data-id": _vm.panelId, text: "Item description:" }
              }),
              _vm._v(" "),
              _c("BlTextBody2", {
                staticClass: "whitespace-pre-line",
                attrs: {
                  "data-id": _vm.panelId,
                  text: _vm.creditPackageItem.description
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.creditPackageItem.status === "archived"
            ? _c(
                "div",
                {
                  staticClass: "flex flex-col gap-2",
                  attrs: { "data-id": _vm.panelId }
                },
                [
                  _c("BlTextBody2", {
                    staticClass: "text-slate-700",
                    attrs: { "data-id": _vm.panelId, text: "Status:" }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { attrs: { "data-id": _vm.panelId } },
                    [
                      _c("BlTextBody2", {
                        attrs: { "data-id": _vm.panelId, text: "Archived on" }
                      }),
                      _vm._v(" "),
                      _c("BlTextBody2", {
                        attrs: {
                          "data-id": _vm.panelId,
                          text: _vm.displayDate({
                            date: _vm.creditPackageItem.archived_at,
                            format: "DD MMMM YYYY"
                          })
                        }
                      }),
                      _vm._v(" "),
                      _c("BlTextBody2", {
                        attrs: { "data-id": _vm.panelId, text: "by" }
                      }),
                      _vm._v(" "),
                      !_vm.creditPackageItem.archiver ||
                      !_vm.creditPackageItem.archiver.name
                        ? _c("BlTextBody2", {
                            staticClass: "italic",
                            attrs: {
                              "data-id": _vm.panelId,
                              text: "Deleted user"
                            }
                          })
                        : _c("BlTextBody2", {
                            attrs: {
                              "data-id": _vm.panelId,
                              text: _vm.creditPackageItem.archiver.name
                            }
                          })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "py-3 px-3 flex items-center justify-between bg-prim-100 rounded",
              attrs: { "data-id": _vm.panelId }
            },
            [
              _c("BlTextBody3", {
                staticClass: "text-light-purple-400",
                attrs: {
                  "data-id": _vm.panelId,
                  text: "Standard retail price (per credit)"
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                { attrs: { "data-id": _vm.panelId } },
                [
                  _c("BlTextSubtitle2", {
                    staticClass: "text-dark-purple-100",
                    attrs: {
                      "data-id": _vm.panelId,
                      text: _vm.currentCenter.currency_sym
                    }
                  }),
                  _vm._v(" "),
                  _c("BlTextSubtitle2", {
                    staticClass: "text-dark-purple-100",
                    attrs: {
                      "data-id": _vm.panelId,
                      text: _vm.priceFormats(
                        _vm.creditPackageItem.standard_retail_price
                      )
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          !_vm.creditPackageItem.users.length
            ? _c(
                "div",
                { attrs: { "data-id": _vm.panelId } },
                [
                  _c("BlTextBody2", {
                    staticClass: "text-slate-700",
                    attrs: {
                      "data-id": _vm.panelId,
                      text:
                        "This item can be applied to appointments with any therapist."
                    }
                  })
                ],
                1
              )
            : _c(
                "div",
                {
                  staticClass: "pb-16 flex flex-col gap-2",
                  attrs: { "data-id": _vm.panelId }
                },
                [
                  _c(
                    "div",
                    { attrs: { "data-id": _vm.panelId } },
                    [
                      _c("BlTextBody2", {
                        staticClass: "text-slate-700",
                        attrs: {
                          "data-id": _vm.panelId,
                          text:
                            "This item is restricted to appointments assigned to the"
                        }
                      }),
                      _vm._v(" "),
                      _c("BlTextBody2", {
                        staticClass: "font-bold text-slate-700",
                        attrs: {
                          "data-id": _vm.panelId,
                          text: _vm.creditPackageItem.users.length
                        }
                      }),
                      _vm._v(" "),
                      _c("BlTextBody2", {
                        staticClass: "text-slate-700",
                        attrs: {
                          "data-id": _vm.panelId,
                          text: "selected therapist(s):"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "flex flex-col",
                      attrs: { "data-id": _vm.panelId }
                    },
                    _vm._l(_vm.creditPackageItem.users, function(user) {
                      return _c(
                        "div",
                        {
                          key: user.id,
                          staticClass:
                            "py-3 flex items-center justify-between gap-4 border-b border-slate-400",
                          attrs: { "data-id": _vm.panelId }
                        },
                        [
                          !user.name
                            ? _c("BlTextSubtitle3", {
                                staticClass: "truncate text-slate-800 italic",
                                attrs: {
                                  "data-id": _vm.panelId,
                                  title: "Deleted user",
                                  text: "Deleted user"
                                }
                              })
                            : _c("BlTextSubtitle3", {
                                staticClass: "truncate text-slate-800",
                                attrs: {
                                  "data-id": _vm.panelId,
                                  title: user.name,
                                  text: user.name
                                }
                              }),
                          _vm._v(" "),
                          _c("BlTextBody2", {
                            staticClass: "text-slate-700",
                            attrs: { "data-id": _vm.panelId, text: user.email }
                          })
                        ],
                        1
                      )
                    }),
                    0
                  )
                ]
              )
        ]
      ),
      _vm._v(" "),
      _vm.editOpened
        ? _c("EditPackageItemModal", {
            attrs: { creditPackageItemId: _vm.creditPackageItem.id },
            on: {
              "close-modal": function($event) {
                _vm.editOpened = false
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.archiveOpened
        ? _c("ArchivePackageItemModal", {
            attrs: { creditPackageItem: _vm.creditPackageItem },
            on: {
              "close-modal": function($event) {
                _vm.archiveOpened = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2ef1201b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ef1201b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/center/packageItem/PackageItemPanel.vue
// module id = null
// module chunks = 